"use strict";


Shopify.theme.jsCustomBakeForm = {
  init: function init($section) {
    this.$section = $section
    this.$cookieWrapper = $section.find('[data-cookie-wrapper]')
    this.form = $section.find('form')
    this.$addWrapper = this.$cookieWrapper.find('[data-add-cookie]')
    this.$template = this.$cookieWrapper.find('[data-added-cookie-skeleton]')
    this.$gooeyWrapper = this.$section.find('[data-gooey-wrapper]')
    
    this.$nav = $section.find('[data-steps]')
    this.$steps = $section.find('.bake-form__step')
    this.cellCount = 0
    
    this.initNav()
    this.initHandlers()
  },
  initHandlers(){
    this.$addWrapper.on('click',function(){
    	const $newCell = $(document.createElement('div'))
        $newCell.html(this.$template.html())
        this.cellCount ++
        this.$cookieWrapper.prepend($newCell.html())
        this.updateIndexes()
    }.bind(this))
    
    this.$section.on('change','[data-quantity-range]',function(e){
    	const $el = $(e.target)
        const $parent = $el.parents('[data-quantity-wrapper]')
        $parent.find('[data-quantity]').val($el.val())
    }.bind(this))
    
    this.$section.on('change','[data-quantity]',function(e){
    	const $el = $(e.target)
        const $parent = $el.parents('[data-quantity-wrapper]')
        $parent.find('[data-quantity-range]').val($el.val())
    }.bind(this))

    
    this.$cookieWrapper.on('click','[data-delete-cell]',function(e){
    	this.cellCount--
        $(e.target).parents('[data-cell]').remove()
        this.updateIndexes()
    }.bind(this))
    
    this.$section.on('change','[data-file-main]',function(e){
    	const $el = $(e.target)
        const files = $el.prop('files');
        const $parent = $el.parents('main')
        const $loader = $parent.find('.is-loading')
        $loader.removeClass('hidden')
        const uploadStatus = []
          for(let i=0;i<files.length;i++){
          uploadStatus[i] = new Promise((resolve, reject) => {
              let form_data = new FormData();     
              let file = files[i]
              let newName = file.name.split(' ').join('-')
              form_data.append('file', files[i],newName);
              $.ajax({
                url: 'https://c2-digitalapps.com/client_apps/cupcake-market-nyc/upload.php', //'https://cartbrain.net/CookiesProfileUploader/upload.php', 
                dataType: 'text',  
                cache: false,
                contentType: false,
                processData: false,
                data: form_data,                         
                type: 'post',
                beforeSend: function(){

                },
                success: function(php_script_response){
                 resolve(php_script_response)
                },
                error:function(e){
                	reject(e)
                },
                complete: function(){

                }
              });
          });
          }
          Promise.all(uploadStatus).then((values) => {
              $loader.addClass('hidden')
              $parent.find('.before-content').addClass('hidden')
              $parent.find('.after-content').removeClass('hidden')
              values.forEach(function(link,index){
                $parent.find('.after-content').prepend(`<span class="filename"><i class="icon check-icon"></i>${files[index].name}</span>`)
              })
              $parent.siblings('[data-files]').val(values)
          });
    }.bind(this))
    
    //STEP 4
     this.$gooeyWrapper.on('change','[data-quantity-range]',function(e){
    	const $el = $(e.target)
        const $parent = $el.parents('[data-quantity-wrapper]')
        const $quantitySelector = $parent.find('[data-quantity]')
        if($quantitySelector.val()>0){
        	$quantitySelector.attr('name',$quantitySelector.data('name'))
        }else{
        	$quantitySelector.removeAttr('name')
        }
    }.bind(this))
     
     this.$gooeyWrapper.on('change','[data-quantity]',function(e){
    	const $el = $(e.target)
        if($el.val()>0){
        	$el.attr('name',$el.data('name'))
        }else{
        	$el.removeAttr('name')
        }
    }.bind(this))
    
  },
  updateIndexes(){
    const $cells = this.$cookieWrapper.find('[data-cell]')
    for(let index=1;index<=this.cellCount;index++){
      let $el = $cells.eq(index-1)
        $el.attr('data-cell-index',index)
        $el.find('[data-category]').attr('name','contact[Cookie '+ index+ ' Type]')
        $el.find('[data-category]').attr('name','contact[Cookie '+ index+ ' Type]')
        $el.find('[data-quantity]').attr('name','contact[Cookie '+ index+ ' Quantity]')
        $el.find('[data-files]').length?
          $el.find('[data-files]').attr('name',`contact[Cookie ${index} Images]`):
          $el.prepend(`<input type="hidden" name="contact[Cookie ${index} Images]" value="" data-files>`)
        $el.find('[data-file-main]').attr('id',`cookie-${index}-files`)
        $el.find('[data-file-main]').parent().attr('for',`cookie-${index}-files`)
    }
  },
  initNav: function(){
  	const $navItems =  this.$nav.find('[data-step]')
    const $steps = this.$steps
    const headerHeight = Shopify.theme.jsHeader.getHeaderHeight()
    let active;
    $(document).on('scroll:CUSTOM',function(){
      
      for(let i = $steps.length-1;i>=0;i--){
        if($(window).scrollTop() < $steps.eq(i).offset().top + headerHeight){
        	active = i
        }
      }
      $navItems.removeClass('is-active')
      $navItems.eq(active).addClass('is-active')
    })
  },
  unload: function unload() {
  }
};